<template>
  <div>
    <div class="announcement-content">
            <div class="announcement-list">
        <div class="title">
          <div class="title-text"><h1>通知公告</h1></div>
          <div class="title-link">
            <router-link to="/announcement/list"
              ><span>更多 &#187;</span></router-link
            >
          </div>
        </div>
        <div
          class="announcement"
          v-for="(item, index) in announcements"
          v-bind:key="index"
        >
          <div class="date">
            <div class="month">
              <div v-if="item.date[5] == 0">{{ item.date[6] }}月</div>
              <div v-else>{{ item.date[5] }}{{ item.date[6] }}月</div>
            </div>
            <div class="day">{{ item.date[8] }}{{ item.date[9] }}</div>
          </div>
          <div class="announcement-title">
            <router-link :to="'/announcement/detail?id=' + item.id">
              <span>{{ item.title }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="publication-list">
        <div class="title">
          <div class="title-text"><h1>科研动态</h1></div>
          <div class="title-link">
            <router-link to="/research/publication/"
              ><span>更多 &#187;</span></router-link
            >
          </div>
        </div>
        <div
          class="publication"
          v-for="(item, index) in publications"
          v-bind:key="index"
        >
          <div class="publication-image">
            <img :src="item.image" />
          </div>
          <div class="publication-content">
            <router-link :to="'/research/publication/detail?id=' + item.id">
              <h5>{{ item.title }}</h5>
            </router-link>
            <div class="description">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      publications: [],
      announcements: [],
    };
  },
  created: function () {
    this.get_latest_publications();
    this.get_latest_announcements();
  },
  methods: {
    get_latest_publications: function () {
      let url = "research/publications/?ordering=-date&p=1&page_size=2";
      this.$http.get(url).then((response) => {
        this.publications = response.data.results;
      });
    },
    get_latest_announcements: function () {
      let url = "announcements/?ordering=-date&p=1&page_size=4";
      this.$http.get(url).then((response) => {
        this.announcements = response.data.results;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
h1 {
  color: #931b22 !important;
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
}
a {
  color: #3e3e3e;
  :hover {
    color: #931b22 !important;
  }
}
.announcement-content {
  margin: 30px 0;
  padding: 0;
  overflow: hidden;
  background-color: #fff;
  h5 {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 15px;
    border-bottom: #d8d8d8 1px solid;
  }
  .publication-list {
    padding: 15px 40px;
    margin-left: 30px;
    background-color: #f5f6fa;
    width: 800px;
    float: left;
    .title {
      height: 50px;
      border-bottom: 4px #931b22 solid;
      .title-text {
        width: 500px;
        float: left;
      }
      .title-link {
        width: 100px;
        float: right;
        padding: 10px;
      }
    }
    .publication {
      clear: both;
      margin: 20px 0;
      padding: 10px 0;
      height: 190px;
      background-color: #fff;
      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.15),
        0 5px 10px 0 rgba(0, 0, 0, 0.1);

      .publication-image {
        float: left;
        margin: 0 10px;
        padding: 0;
        width: 252px;
        border: #d1d1d1 1px solid;
        img {
          width: 250px;
        }
      }
      .publication-content {
        float: left;
        width: 420px;
        margin-left: 10px;
        padding: 10px 10px;
        .description {
          padding-top: 10px;
          color: #565656;
          font-size: 14px;
          text-align: justify;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .announcement-list {
    padding: 15px 40px 15px 40px;
    margin-left: 0;
    background-color: #f5f6fa;
    width: 470px;
    float: left;
    .title {
      height: 50px;
      border-bottom: 4px #931b22 solid;
      .title-text {
        width: 180px;
        float: left;
      }
      .title-link {
        width: 100px;
        float: right;
        padding: 10px;
      }
    }
    .announcement {
      padding: 15px 5px 15px 20px;
      height: 90px;
      background-color: #fff;
      margin: 20px 0 0 0;
      .date {
        width: 60px;
        height: 60px;
        background-color: #f5f6fa;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.15),
          0 5px 10px 0 rgba(0, 0, 0, 0.1);
        border-radius: 15px;
        float: left;
        font-weight: bold;
        .month {
          height: 30px;
          padding-top: 5px;
          font-size: 16px;
          color: #f5f6fa;
          text-align: center;
          background-color: #557a95;
          border-top-left-radius: 15px;
          border-top-right-radius: 15px;
        }
        .day {
          height: 30px;
          font-size: 20px;
          color: #565656;
          text-align: center;
          margin: 0 5px;
        }
      }
      .announcement-title {
        float: left;
        width: 270px;
        margin: 5px 5px;
        padding: 0 0 0 10px;
        font-size: 16px;
        text-align: justify;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>
